import { render, staticRenderFns } from "./view_edit.vue?vue&type=template&id=997002e8&scoped=true"
import script from "./view_edit.vue?vue&type=script&lang=js"
export * from "./view_edit.vue?vue&type=script&lang=js"
import style0 from "./view_edit.vue?vue&type=style&index=0&id=997002e8&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "997002e8",
  null
  
)

export default component.exports